import Icon, {editFileIcon, editIcon, plusIcon, trashIcon} from "../../components/Icon/Icon";
import Table from "../../components/Table/Table";
import { useEffect, useMemo, useState } from "react";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import Button from "../../components/Button/Button";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../hooks/useNotification";
import PageLayout from "../../components/PageLayout/PageLayout";
import FormActions from "../../api/FormsActions";
import FormModal from "./FormModal";

const Forms = () => {
    const [forms, setForms] = useState([]);
    const [deleteModal, setDeleteModal] = useState(null);
    const [modal, setModal] = useState(null);
    const { triggerNotification } = useNotification();
    const navigate = useNavigate();

    useEffect(() => {
        FormActions.loadForms(setForms);
    }, []);

    const columns = useMemo(() => [
        {
            accessorKey: 'name',
            header: 'Form name',
            cell: ({ row }) => {
                return <span>{row.original.name}</span>;
            },
        },
        {
            accessorKey: 'actions',
            header: 'Actions',
            cell: ({ row }) => {
                const {id} = row.original;
                console.log(id)

                return (
                    <div className="actions">
                        <Button variant="action" onClick={() => navigate(`/forms/create_form/${id}`)}>
                            <Icon svg={editFileIcon} className="builder" />
                        </Button>

                        <Button variant="action" onClick={() => setModal(row.original)}>
                            <Icon svg={editIcon} className="edit" />
                        </Button>

                        <Button variant="action" onClick={() => setDeleteModal(row.original)}>
                            <Icon svg={trashIcon} className="trash" />
                        </Button>
                    </div>
                );
            },
        }
    ], [forms]);


    return (
        <PageLayout
           titlePage="Forms"
           actions={
               <Button className="add" onClick={() => setModal({})}>
                   <Icon svg={plusIcon} />
                   Add New
               </Button>
           }
        >
            <Table data={forms} columns={columns}></Table>

            {
                deleteModal &&
                <DeleteModal
                    onClose={() => setDeleteModal(null)}
                    onConfirm={() => FormActions.deleteForm(deleteModal.id, () => {
                        setForms(forms.filter(form => form.id !== deleteModal.id));
                        setDeleteModal(null);
                        triggerNotification("Form deleted successfully");
                    })}
                    title={"Deleting form"}
                    message={`Are you sure you want to delete form "${deleteModal.name}"?`}
                />
            }
            {
                modal &&
                <FormModal
                    onClose={() => setModal(null)}
                    form={modal}
                    onSubmit={values => {
                        FormActions.save(values, res => {
                            if(values.id){
                                setForms(forms.map(form => form.id === values.id ? res : form));
                                triggerNotification("Form updated successfully");
                            }else{
                                setForms([...forms, res]);
                                triggerNotification("Form created successfully");
                            }

                            setModal(null);
                        })
                    }}
                />
            }
        </PageLayout>
    );
};

export default Forms;